<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <video id="out" src="../../assets/audios/out.wav" style="display:none"></video>
          <Form inline>
            <h2 style="color: #000;margin-bottom: 5px">操作提示，请您阅读!</h2>
            <h2 style="color: red;margin-bottom: 5px">搜索没有选择状态时,默认搜索待处理的订单</h2>
          </Form>
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Select multiple v-model='searchConf.setting_pay_channel_id' clearable
                      :placeholder="$t('提现卡类型') " style='width:180px'>
                <Option :key="key" :value="value.id.toString()"
                        v-for="(value, key) in extraParams.payChannelArray"> {{ value.pay_name }}
                </Option>
              </Select>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.withdraw_money_min' :placeholder="$t('金额下限') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.withdraw_money_max' :placeholder="$t('金额上限') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.ip' :placeholder="$t('用户IP') "></Input>
            </FormItem>
          </Form>
          <div style="border-bottom: 1px solid lightgray;padding-bottom:10px;margin-bottom: 10px;margin-top: 5px"></div>
          <Form inline>
            <FormItem style="margin-bottom: 0">
              <DatePicker type="datetimerange" :options="timeOptions" :value='searchConf.searchTime'
                          @on-change='timeChange' format="yyyy-MM-dd HH:mm:ss"
                          :placeholder="$t('选择时间')" style="width: 200px">
              </DatePicker>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.username' :placeholder="$t('用户名') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.serial_num' :placeholder="$t('订单号') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Select v-model='searchConf.status' clearable :placeholder="$t('状态') " @on-change='changeSelectStatus'
                      style='width:120px'>
                <Option :value="'0'">{{ $t('未处理') }}</Option>
                <Option :value="'1'">{{ $t('挂起') }}</Option>
                <Option :value="'2'">{{ $t('退回') }}</Option>
                <Option :value="'3'">{{ $t('没收') }}</Option>
                <Option :value="'4'">{{ $t('成功') }}</Option>
                <Option :value="'5'">{{ $t('等待代付') }}</Option>
                <Option :value="'6'">{{ $t('全部') }}</Option>
              </Select>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t('find_button') }}</Button>
            </FormItem>
            <FormItem label=" 自动刷新" style="margin-left: 40px; width: 150px">
              <i-Switch id="switch" v-model="timerIsOpen" @on-change="openTimeGetList(10000)"
                        size="large">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-Switch>
            </FormItem>


            <ButtonGroup id="btn">
              <Button id="one" :disabled="disabled" :class="{active: countDown === 10000}"
                      @click="openTimeGetList(10000)">10秒
              </Button>
              <Button id="two" :disabled="disabled" :class="{active: countDown === 15000}"
                      @click="openTimeGetList(15000)">15秒
              </Button>
              <Button id="three" :disabled="disabled" :class="{active: countDown === 30000}"
                      @click="openTimeGetList(30000)">30秒
              </Button>
              <Button id="four" :disabled="disabled" :class="{active: countDown === 60000}"
                      @click="openTimeGetList(60000)">1分钟
              </Button>
            </ButtonGroup>

            <FormItem label="自动三方出款" style="margin-left: 40px; width: 170px">
              <i-Switch id="switch" v-model="extraParams.is_auto_withdraw==1"  @on-change="changeIsAutoWithdraw"
                        size="large">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-Switch>
            </FormItem>

          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' v-has="'financeManage/withdrawPending/add'" @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table  ref="selection" @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
            <div style="margin-top: 16px">
              <Button @click="handleSelectAll()">{{$t('全选')}}</Button>
              <Button @click="thirdWithdrawAllSelect()" type="warning">{{$t('批量第三方出款')}}</Button>
            </div>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowChange.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowChangeCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('消息提示') }}</span>
      </p>

      <Form ref="windowChangeForm" :rules="windowChangeValidate" :model="windowChangeItem" :label-width="80"
            label-position="left">
         <span>{{
             windowChangeItem.status == 4 ? '确认该订单已打款(或代付已成功),订单' : windowChangeItem.status == 2 ? '退回订单(该笔提现退回,提现金额返回用户账户) '
               : windowChangeItem.status == 3 ? '没收订单(该笔提现不退回)' : '挂起订单'
           }}

        <i class="indentNum">{{ windowChangeItem.serial_num }}</i>备注 :
      </span>
        <FormItem label='备注' prop='remark'>
          <Input v-model='windowChangeItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowChangeCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowChangeSubmit" :loading="windowChange.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <Modal v-model="windowThirdWidthdraw.show" width="668" :styles="{top: '30px'}"
           @on-visible-change="windowThirdWidthdrawCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ $t('第三方出款') }}</span>
      </p>
      <Form ref="windowThirdWidthdrawForm" :rules="windowThirdWidthdrawValidate" :model="windowThirdWidthdrawItem"
            :label-width="80" label-position="left">
        <FormItem label='选择代付通道' prop='pay_channels_id'>
          <Select v-model='windowThirdWidthdrawItem.pay_channels_id' style='width:200px'>
            <Option :key="key" :value="value.id.toString()"
                    v-for="(value, key) in extraParams.thirdArrayNew"> {{ value.title }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label='备注' prop='remark'>
          <Input v-model='windowThirdWidthdrawItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowThirdWidthdrawCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowThirdWidthdrawSubmit" :loading="windowThirdWidthdraw.loading">
          {{ $t('确定') }}
        </Button>
      </div>
    </Modal>
    <Modal v-model="windowMsg.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowMsgCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowMsgItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowMsgForm" :rules="windowMsgValidate" :model="windowMsgItem" :label-width="80"
            label-position="left">
        <FormItem label='用户名' prop='username'>
          <Input v-model='windowMsgItem.username' :placeholder="$t('请输入用户名')"></Input>
        </FormItem>
        <FormItem label='提现卡类型' prop='setting_pay_channel_id_name'>
          <Input v-model='windowMsgItem.setting_pay_channel_id_name' :placeholder="$t('请输入提现卡类型')"></Input>
        </FormItem>
        <FormItem label='提现金额' prop='withdraw_money'>
          <Input v-model='windowMsgItem.withdraw_money' :placeholder="$t('请输入提现金额')"></Input>
        </FormItem>
        <FormItem label='p1' prop='p1'>
          <Input v-model='windowMsgItem.p1' :placeholder="$t('请输入p1')"></Input>
        </FormItem>
        <FormItem label='p2' prop='p2'>
          <Input v-model='windowMsgItem.p2' :placeholder="$t('请输入p2')"></Input>
        </FormItem>
        <FormItem label='p3' prop='p3'>
          <Input v-model='windowMsgItem.p3' :placeholder="$t('请输入p3')"></Input>
        </FormItem>
        <FormItem label='p4' prop='p4'>
          <Input v-model='windowMsgItem.p4' :placeholder="$t('请输入p4')"></Input>
        </FormItem>
        <FormItem label='p5' prop='p5'>
          <Input v-model='windowMsgItem.p5' :placeholder="$t('请输入p5')"></Input>
        </FormItem>
        <FormItem label='p6' prop='p6'>
          <Input v-model='windowMsgItem.p6' :placeholder="$t('请输入p6')"></Input>
        </FormItem>
        <FormItem label='p7' prop='p7'>
          <Input v-model='windowMsgItem.p7' :placeholder="$t('请输入p7')"></Input>
        </FormItem>
        <FormItem label='p8' prop='p8'>
          <Input v-model='windowMsgItem.p8' :placeholder="$t('请输入p8')"></Input>
        </FormItem>
        <FormItem label='p9' prop='p9'>
          <Input v-model='windowMsgItem.p9' :placeholder="$t('请输入p9')"></Input>
        </FormItem>
        <FormItem label='p10' prop='p10'>
          <Input v-model='windowMsgItem.p10' :placeholder="$t('请输入p10')"></Input>
        </FormItem>
        <FormItem label='上级帐号' prop='top_id'>
          <Input v-model='windowMsgItem.top_id' :placeholder="$t('请输入上级帐号')"></Input>
        </FormItem>
        <FormItem label='注册时间' prop='register_time'>
          <Input v-model='windowMsgItem.register_time' :placeholder="$t('请输入注册时间')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowMsgCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowMsgSubmit" :loading="windowMsg.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus,
  thirdWidthdraw,
  changeIsAutoWithdraw
} from '@/api/financeManage/withdrawPending'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [  {
        type: 'selection',
        width: 60,
        align: 'center'
      },{
        title: this.$t('单号'),
        key: 'serial_num',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('会员帐号'),
        key: 'username',

        minWidth: 120,
        align: 'center'
      }
        // ,
        //   {
        //   title: this.$t('提现币种/汇率'),
        //   key: 'withdrawCEM',
        //   minWidth: 180,
        //   align: 'center'
        // }
        ,
        {
          title: this.$t('提现卡'),
          align: 'center',
          minWidth: 250,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('(') +(params.row.p1_name?params.row.p1_name:'')+ '):' + (params.row.p1_value?params.row.p1_value:params.row.p1)), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('(') +(params.row.p2_name?params.row.p2_name:'')+ '):' + (params.row.p2_value?params.row.p2_value:params.row.p2)), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('(') +(params.row.p3_name?params.row.p3_name:'')+ '):' + (params.row.p3_value?params.row.p3_value:params.row.p3)),])
          }
        },
        {
          title: this.$t('提现'),
          align: 'center',
          minWidth: 250,
          render: (h, params) => {
            let vm = this
            return h('div', [h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('申领金额：') +(params.row.withdraw_money?params.row.withdraw_money:'')), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('手续费：') +(params.row.withdraw_commission?params.row.withdraw_commission:'')), h('p', {
              style: {
                textAlign: 'left',
                marginLeft: '5px'
              }
            }, this.$t('总金额：') +(params.row.withdraw_money_all?params.row.withdraw_money_all:'')),])
          }
        }
        // ,
        //   {
        //   title: this.$t('兑换后提现金额'),
        //   key: 'withdraw_money',
        //
        //   minWidth: 120,
        //   align: 'center'
        // }
        , {
          title: this.$t('提现卡类型'),
          key: 'setting_pay_channel_id_name',
          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('7日提现/充值'),
          key: 'sevenDayWandR',
          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('申请时间'),
          key: 'add_time',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('是否代付'),
          align: 'center',
          minWidth: 110,
          key: 'is_third',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.is_third ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.is_third ? '1px solid #ed4014' : '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, (params.row.is_third ? this.$t('是') : this.$t('否'))),
              params.row.third_name
            ])
          }
        }, {
          title: this.$t('状态'),
          align: 'center',
          minWidth: 80,
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  color: params.row.status != 4 ? '#ed4014' : '#19be6b',
                  borderRadius: '11px',
                  border: params.row.status != 4 ? '1px solid #ed4014' : '1px solid #19be6b',
                  display: '',
                  height: '25px',
                  width: '70%',
                  lineHeight: '25px',
                  padding: '3px'
                },
              }, params.row.status == 0 ? this.$t('待处理') : params.row.status == 1 ? this.$t('挂起中') : params.row.status == 2 ? this.$t('已退回') : params.row.status == 3 ? this.$t('已没收') : params.row.status == 5 ? this.$t('等待代付') : this.$t('成功')),
            ])
          }
        }, {
          title: this.$t('操作'),
          align: 'center',
          minWidth: 350,
          render: (h, params) => {
            let vm = this
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: params.row.status <= 1 || params.row.status == 5 ? false : true
                },
                style: {
                  margin: '0 2px',
                },
                on: {
                  'click': () => {
                    this.windowChangeItem.id = params.row.id
                    this.windowChangeItem.status = 4
                    this.windowChangeItem.serial_num = params.row.serial_num
                    this.windowChangeItem.remark = params.row.remark
                    this.windowChange.show = true
                  }
                }
              }, params.row.status == 5 ? this.$t('手动确认代付') : this.$t('确认')),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.status <= 1 ? false : true
                },
                style: {
                  margin: '0 2px',
                  display: params.row.status == 5 ? 'none' : ''
                },
                on: {
                  'click': () => {
                    this.windowChangeItem.id = params.row.id
                    this.windowChangeItem.status = 2
                    this.windowChangeItem.serial_num = params.row.serial_num
                    this.windowChangeItem.remark = params.row.remark
                    this.windowChange.show = true
                  }
                }
              }, this.$t('退回')),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.status <= 1 ? false : true
                },
                style: {
                  margin: '0 2px',
                  display: params.row.status == 5 ? 'none' : ''
                },
                on: {
                  'click': () => {
                    this.windowChangeItem.id = params.row.id
                    this.windowChangeItem.status = 3
                    this.windowChangeItem.serial_num = params.row.serial_num
                    this.windowChangeItem.remark = params.row.remark
                    this.windowChange.show = true
                  }
                }
              }, this.$t('没收')),
              h('Poptip', {
                  props: {
                    confirm: true,
                    title: this.$t('确定要挂起?'),
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.windowChangeItem.id = params.row.id
                      this.windowChangeItem.status = 1
                      this.windowChangeItem.remark = params.row.remark

                      changeStatus(this.windowChangeItem).then(response => {
                        this.$Message.success(response.data.msg)
                        this.getList()
                      })
                      params.loading = false
                    }
                  }
                },
                [h('Button', {
                  style: {
                    margin: '0 2px',
                    display: params.row.status == 5 ? 'none' : ''
                  },
                  props: {
                    type: this.$t('info'),
                    placement: 'top',
                    loading: params.isDeleting,
                    disabled: params.row.status > 0,
                    size: 'small'
                  }
                }, this.$t('挂起'))]),
              h('Poptip', {
                  props: {
                    confirm: true,
                    title: this.$t('订单已提交到三方代付,请确认该笔订单代付失败,再进行恢复,确认要恢复到待处理状态?'),
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.windowChangeItem.id = params.row.id
                      this.windowChangeItem.status = 0
                      this.windowChangeItem.remark = params.row.remark
                      this.windowChangeItem.is_third = params.row.is_third
                      changeStatus(this.windowChangeItem).then(response => {
                        this.$Message.success(response.data.msg)
                        this.getList()
                      })
                      params.loading = false
                    }
                  }
                },
                [h('Button', {
                  style: {
                    margin: '0 2px',
                    display: params.row.status == 5 ? '' : 'none'
                  },
                  props: {
                    type: this.$t('info'),
                    placement: 'top',
                    loading: params.isDeleting,
                    disabled: params.row.status != 5,
                    size: 'small'
                  }
                }, this.$t('恢复'))]),
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                  disabled: params.row.status <= 1 ? false : true
                },
                style: {
                  margin: '0 2px',
                },
                on: {
                  'click': () => {
                    this.windowThirdWidthdrawItem.id = params.row.id
                    this.windowThirdWidthdrawItem.remark = params.row.remark
                    //三方通道选择只有允许这个订单的支付方式的
                    this.extraParams.thirdArrayNew = this.extraParams.settingPayChannelThirdArray
                    // for (var key in this.extraParams.settingPayChannelThirdArray) {
                    //   var third_support_setting_pay_channel_ids = this.extraParams.settingPayChannelThirdArray[key]['third_support_setting_pay_channel_ids']
                    //   if (third_support_setting_pay_channel_ids) {
                    //     if (third_support_setting_pay_channel_ids.includes(params.row.setting_pay_channel_id.toString())) {
                    //       this.extraParams.thirdArrayNew.push(this.extraParams.settingPayChannelThirdArray[key])
                    //     }
                    //   } else {
                    //     this.extraParams.thirdArrayNew.push(this.extraParams.settingPayChannelThirdArray[key])
                    //   }
                    //
                    // }
                    // console.log(this.extraParams.thirdArrayNew)
                    this.windowThirdWidthdraw.show = true
                  }
                }
              }, this.$t('第三方出款')),])
          }
        }, {
          title: this.$t('备注'),
          key: 'remark',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('用户IP'),
          key: 'ip',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('操作员'),
          key: 'admin_name',

          minWidth: 120,
          align: 'center'
        }, {
          title: this.$t('操作时间'),
          key: 'update_time',

          minWidth: 120,
          align: 'center'
        },],
      isSelectAll:false,
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段

      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowChange: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowChangeItem: { //弹窗数据绑定
        id: 0
      },
      windowChangeValidate: {//窗口校验规则
      }, windowThirdWidthdraw: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowThirdWidthdrawItem: { //弹窗数据绑定
        id: 0
      },
      windowThirdWidthdrawValidate: {//窗口校验规则
      }, windowMsg: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      extraParams: [],
      windowMsgItem: { //弹窗数据绑定
        id: 0
      },
      windowMsgValidate: {//窗口校验规则
      },
      paramsArray: [],
      timer: '',
      timerIsOpen: true,
      countDown: 10000,
      //----------------
    }
  },
  created () {
    let vm = this
    this.searchConf.username = this.$route.params.username ? this.$route.params.username : ''
    this.searchConf.status = this.$route.params.username ? '6' : ''
    vm.getList()
    vm.hasRule('financeManage/withdrawPending/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('financeManage/withdrawPending/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('financeManage/withdrawPending/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  mounted () {
    this.getParams()
    if (this.timerIsOpen == true) {
      this.openTimeGetList(15000)
    }
  },
  beforeDestroy () {
    if (this.timer) {
      //如果定时器还在运行 或者直接关闭，不用判断
      clearTimeout(this.timer) //关闭
    }

  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAdd.show = true
    },
    getParams () {
      getParams().then(response => {
        this.extraParams = response.data.data
      })
    },
    changeIsAutoWithdraw (isOpen) {
      let is_auto_withdraw=isOpen==true?1:0;
      if(isOpen){
        //三方通道选择只有允许这个订单的支付方式的
        this.extraParams.thirdArrayNew = this.extraParams.settingPayChannelThirdArray
        this.windowThirdWidthdraw.isAutoWithdraw=true;
        this.windowThirdWidthdraw.show = true
      }else{
        changeIsAutoWithdraw(is_auto_withdraw,0).then(response => {
          vm.$Message.success(response.data.msg)
        })
      }
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
        if (response.data.data.pendingCount > 0) {
          let audio = document.getElementById('out')
          audio && audio.play()
        }
      })
    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowChangeCancel (data) {
      if (!data) {
        this.windowChangeItem.id = 0
        this.$refs['windowChangeForm'].resetFields()
        this.windowChange.show = false
        this.windowChange.loading = false
        this.windowChange.index = 0
      }
    }, windowChangeSubmit () {
      let vm = this
      vm.$refs['windowChangeForm'].validate((valid) => {
        if (valid) {
          vm.windowChange.loading = true
          changeStatus(this.windowChangeItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowChangeCancel()
          }).catch(() => {
            vm.windowChange.loading = false
          })
        }
      })
    }, windowThirdWidthdrawCancel (data) {
      if (!data) {
        this.windowThirdWidthdrawItem.id = 0
        this.$refs['windowThirdWidthdrawForm'].resetFields()
        this.windowThirdWidthdraw.show = false
        this.windowThirdWidthdraw.loading = false
        this.windowThirdWidthdraw.index = 0
        this.windowThirdWidthdraw.isAutoWithdraw=false;
        this.getParams()
      }
    }, windowThirdWidthdrawSubmit () {
      let vm = this
      vm.$refs['windowThirdWidthdrawForm'].validate((valid) => {
        if (valid) {
          vm.windowThirdWidthdraw.loading = true
          if( vm.windowThirdWidthdraw.isAutoWithdraw==true){
            //设置自动出款时
            changeIsAutoWithdraw(1,vm.windowThirdWidthdrawItem.pay_channels_id).then(response => {
              vm.$Message.success(response.data.msg)
              vm.windowThirdWidthdrawCancel()
              vm.getParams()
            })
          }else{
            //非设置自动出款
            thirdWidthdraw(vm.windowThirdWidthdrawItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.windowThirdWidthdrawCancel()
            }).catch(() => {
              vm.windowThirdWidthdraw.loading = false
            })
          }

        }
      })
    }, changeSelectStatus (value) { //时间修改，自动计算尾部时间
      if (value >= 0) {
        this.timerIsOpen = false
      } else {
        this.timerIsOpen = true
        this.openTimeGetList(this.countDown)
      }

    }, openTimeGetList (time) {//倒计时,去循环GETLIST
      this.countDown = time
      if (this.timer) {
        clearTimeout(this.timer)
      }
      if (this.timerIsOpen == false) {
        return
      }
      this.timer = setTimeout(() => {
        this.openTimeGetList(time)
      }, time)
      this.getList()
    }, windowMsgCancel (data) {
      if (!data) {
        this.windowMsgItem.id = 0
        this.$refs['windowMsgForm'].resetFields()
        this.windowMsg.show = false
        this.windowMsg.loading = false
        this.windowMsg.index = 0
      }
    }, windowMsgSubmit () {
      let vm = this
      vm.$refs['windowMsgForm'].validate((valid) => {
        if (valid) {
          vm.windowMsg.loading = true
          add(vm.windowMsgItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowMsgCancel()
          }).catch(() => {
            vm.windowMsg.loading = false
          })
        }
      })
    },
    handleSelectAll () {
      if(this.isSelectAll==false){
        this.isSelectAll=true
        this.$refs.selection.selectAll(true);

      }else{
        this.isSelectAll=false
        this.$refs.selection.selectAll(false);
        this.openTimeGetList(30000)
      }

    },
    thirdWithdrawAllSelect () {//三方出款,所有选中项目
      //
      let ids=[];
      this.$refs.selection.getSelection().forEach(function(v, k) {
        ids.push(v.id)
      });
      if(ids.length==0){
        this.$Message.error('未选中,请重新选择')
        return ;
      }else{
        this.$Message.success('选中了'+ids.length+'项数据')
      }

      this.windowThirdWidthdrawItem.id = ids;
      //三方通道选择只有允许这个订单的支付方式的
      this.extraParams.thirdArrayNew = this.extraParams.settingPayChannelThirdArray
      this.windowThirdWidthdraw.show = true
    },
  }
}
</script>
